import React from 'react'
import { Container, Typography, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    pagetitle:{
     color: '#231f20',
     fontFamily:'Poppins',
     paddingTop:'30px',
     fontSize: '42px'
   },
   pagesubtitle:{
    paddingBottom: '40px', 
    fontFamily: 'Poppins'
   },
 }));
 
export default function Vinylcoated() {
    const classes = useStyles();
    return (
        <div>            
            <Container maxWidth="sm" component="main" className={classes.heroContent}>
             <Typography  align="center"className={classes.pagetitle} gutterBottom>
             STAINLESS STEEL BLOCKS
            </Typography>   
            <Grid container justify="center" alignItems="center" >
       <img src="https://i.ytimg.com/vi/I1P3tWm4WXs/maxresdefault.jpg" alt="" style={{ height: '200px', margin: '10px'}}/>
           </Grid> 
                <Typography className={classes.pagesubtitle} align="center" className={classes.pagesubtitle}>
                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                </Typography>      
             </Container>
        </div>
    )
}
